export const SET_ANIMATION_PUSH_UP = 'SET_ANIMATION_PUSH_UP';
export const SET_ANIMATION_SLIDE_LEFT = 'SET_ANIMATION_SLIDE_LEFT';
export const SET_ANIMATION_SLIDE_RIGHT = 'SET_ANIMATION_SLIDE_RIGHT';
export const RESET_ANIMATIONS = 'RESET_ANIMATIONS';
